const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as string | undefined;

export default function PaymentTestModeBanner() {
  if (!clientToken) {
    return (
      <div className="w-full bg-red-100 border-b border-red-300 px-4 py-2 text-center text-sm text-red-800">
        Pagamenti di produzione non configurati. Completa il go-live di Stripe per accettare pagamenti reali.
      </div>
    );
  }
  if (clientToken.startsWith("pk_test_")) {
    return (
      <div className="w-full bg-orange-100 border-b border-orange-300 px-4 py-2 text-center text-sm text-orange-800">
        Modalità test: i pagamenti in preview non sono reali. Usa la carta 4242 4242 4242 4242.
      </div>
    );
  }
  return null;
}
